import React from 'react';
import {
  IonIcon,
  IonLabel,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonBackButton,
  IonList,
  IonItem,
  IonContent,
  IonSpinner
} from '@ionic/react';
import { documentAttachOutline } from 'ionicons/icons';
import { connect } from 'react-redux'
import { Plugins } from '@capacitor/core';

import MaterialActions from '../../../../actions/material';
import { SERVER_EDU_CODESII } from '../../../../constants/system';
import ErrorAlert from '../../../../components/ErrorAlert';

interface Props {
  getTasks: any;
}

interface ClassState {
  data: any;
  match: any;
}

const { Browser } = Plugins;
class Material extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  componentDidMount(){
    if(this.state.data.tasks.length === 0){
      this.props.getTasks({code: this.state.match.params.child, evi: this.state.match.params.evi}, "get_child_tasks");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { child } = this.state.match.params;
    const { user, material, evi, error, error401, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref={`/progress/${ child }/pro`} />
            </IonButtons>
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">{evi.descripcion}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <IonList>
            <h1 style={material.length === 0 && !error && !error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
            {material.map((val:any, key:any) => {
              return (
                <IonItem key={key}>
                  <IonLabel>
                    <h2>{key+1}-{val.archivos}</h2>
                  </IonLabel>
                <a slot="end" onClick={() => Browser.open({ url: `${ SERVER_EDU_CODESII }public/uploaded/tareas/${ val.strfiles }` })}><IonIcon icon={documentAttachOutline} color="primary" slot="end"/></a>
                </IonItem>
              );
            })}
          </IonList>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTasks: (fields: any, typeOptions: string) => dispatch(MaterialActions.getTasks(fields, typeOptions))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Material);
